import React from 'react';
import PropTypes from 'prop-types';
import Widget from '../../../../common/Widget/Widget';
import { formatNumberToUnits } from '../../../../../utils/NumberUtils';

// PHOB-1857: unified TV deterministic reach, split per source. One Widget fetches every selected
// source's household count together (Promise.all), rendered as "ACR: 84K HH | Streaming: 72K HH".
const UnifiedTvDeterministicReach = ({ sources, getReachForSource }) => {
  const sourceValues = sources.map((source) => source.value);
  return (
    <div className="estimated-reach-component">
      <span className="estimated-reach-label">Estimated reach: </span>
      <div className="reach">
        <Widget
          name="UnifiedTvDeterministicReach"
          dataService={() => Promise.all(sources.map((source) => getReachForSource(source.value)))}
          dataServiceParams={sourceValues}
          renderOnValueChange={sourceValues}
          isSmallSpinner={true}
          onRender={(reachNumbers) => (
            <span className="estimated-reach-per-source">
              {sources
                .map((source, index) => {
                  const value = reachNumbers[index];
                  const numDecimals = value >= 1000000 ? 1 : 0;
                  return `${source.label}: ${formatNumberToUnits(value, numDecimals)} HH`;
                })
                .join(' | ')}
            </span>
          )}
        />
      </div>
    </div>
  );
};

UnifiedTvDeterministicReach.propTypes = {
  sources: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })).isRequired,
  getReachForSource: PropTypes.func.isRequired,
};

export default UnifiedTvDeterministicReach;
